module.exports = function() {
  return new Worker(__webpack_public_path__ + "7c5c1215a710514b85db.worker.js");
};